// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkAssignmentController from "./bulk_assignment_controller"
application.register("bulk-assignment", BulkAssignmentController)

import CachedFormController from "./cached_form_controller"
application.register("cached-form", CachedFormController)

import CandidateSelectionController from "./candidate_selection_controller"
application.register("candidate-selection", CandidateSelectionController)

import CardController from "./card_controller"
application.register("card", CardController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CustomTooltipController from "./custom_tooltip_controller"
application.register("custom-tooltip", CustomTooltipController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterbarController from "./filterbar_controller"
application.register("filterbar", FilterbarController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormMultiSelectController from "./form_multi_select_controller"
application.register("form-multi-select", FormMultiSelectController)

import FormPreviewRefresherController from "./form_preview_refresher_controller"
application.register("form-preview-refresher", FormPreviewRefresherController)

import FormSelectController from "./form_select_controller"
application.register("form-select", FormSelectController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InfoModalController from "./info_modal_controller"
application.register("info-modal", InfoModalController)

import LeftMenuController from "./left_menu_controller"
application.register("left-menu", LeftMenuController)

import LeniencyEntryController from "./leniency_entry_controller"
application.register("leniency-entry", LeniencyEntryController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import ListOrderController from "./list_order_controller"
application.register("list-order", ListOrderController)

import LocalSearchController from "./local_search_controller"
application.register("local-search", LocalSearchController)

import MailTemplateController from "./mail_template_controller"
application.register("mail-template", MailTemplateController)

import MediaController from "./media_controller"
application.register("media", MediaController)

import MediaItemSharesController from "./media_item_shares_controller"
application.register("media-item-shares", MediaItemSharesController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import NewsController from "./news_controller"
application.register("news", NewsController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import OverviewListController from "./overview_list_controller"
application.register("overview-list", OverviewListController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import RadioButtonsSelectController from "./radio_buttons_select_controller"
application.register("radio-buttons-select", RadioButtonsSelectController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import ReportSettingsController from "./report_settings_controller"
application.register("report-settings", ReportSettingsController)

import ScoreSelectController from "./score_select_controller"
application.register("score-select", ScoreSelectController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SelectedRowController from "./selected_row_controller"
application.register("selected-row", SelectedRowController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SubscriptionFormController from "./subscription_form_controller"
application.register("subscription-form", SubscriptionFormController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboFrameMissingHandlerController from "./turbo_frame_missing_handler_controller"
application.register(
  "turbo-frame-missing-handler",
  TurboFrameMissingHandlerController,
)

import UploadController from "./upload_controller"
application.register("upload", UploadController)
